import { createI18n } from 'vue-i18n'

import store from '../store';

function loadLocaleMessages () {
    const locales = import.meta.glob('../locales/**/*.json',  { eager: true })
    const messages = {}

    for (const path in locales) {
        const filename = path.split('/').at(-1)
        const locale = filename.endsWith('.json') ? filename.slice(0, -'.json'.length) : filename

        messages[locale] = locales[path];
    }

    return messages
}

export default createI18n({
    legacy: false,
    globalInjection: true,
    locale: store.getters.locale || 'nl',
    fallbackLocale: 'en',
    messages: loadLocaleMessages()
});
